import apiSlice from 'renderer/shared/state/apiSlice';
import {
  CreateDiscountRequest,
  CreateDiscountResponse,
  CreateDiscountResponseSchema,
  DeleteDiscountRequest,
  DeleteDiscountResponse,
  DeleteDiscountResponseSchema,
  GetDiscountRequest,
  GetDiscountResponse,
  GetDiscountResponseSchema,
  ListDiscountsRequest,
  ListDiscountsResponse,
  ListDiscountsResponseSchema,
  UpdateDiscountRequest,
  UpdateDiscountResponse,
  UpdateDiscountResponseSchema,
} from '../schemas/discounts.schemas';

const extendedApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listDiscounts: builder.query<ListDiscountsResponse, ListDiscountsRequest>({
      query: () => '/discount',
      providesTags: ['Discount'],
      extraOptions: {
        responseSchema: ListDiscountsResponseSchema,
      },
    }),
    getDiscount: builder.mutation<GetDiscountResponse, GetDiscountRequest>({
      query: (code) => ({
        url: `/discount/${code}`,
        method: 'GET',
      }),
      // providesTags: ['Discount'],
      extraOptions: {
        responseSchema: GetDiscountResponseSchema,
      },
    }),
    createDiscount: builder.mutation<
      CreateDiscountResponse,
      CreateDiscountRequest
    >({
      query: (body) => ({
        url: '/discount',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Discount'],
      extraOptions: {
        responseSchema: CreateDiscountResponseSchema,
      },
    }),
    updateDiscount: builder.mutation<
      UpdateDiscountResponse,
      UpdateDiscountRequest
    >({
      query: (req) => ({
        url: `/discount/${req._id}`,
        method: 'PUT',
        body: req,
      }),
      invalidatesTags: ['Discount'],
      extraOptions: {
        responseSchema: UpdateDiscountResponseSchema,
      },
    }),
    deleteDiscount: builder.mutation<
      DeleteDiscountResponse,
      DeleteDiscountRequest
    >({
      query: (id) => ({
        url: `/discount/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Discount'],
      extraOptions: {
        responseSchema: DeleteDiscountResponseSchema,
      },
    }),
  }),
});

export const {
  useListDiscountsQuery,
  useGetDiscountMutation,
  useCreateDiscountMutation,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
} = extendedApi;
